import { render, staticRenderFns } from "./AccountFormSettingGamesComponent.vue?vue&type=template&id=788bf2b9&"
import script from "./AccountFormSettingGamesComponent.vue?vue&type=script&lang=js&"
export * from "./AccountFormSettingGamesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports